import React from 'react';
import { Link } from 'react-router-dom';

const ForbiddenPage = () => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '60vh',
      padding: '2rem',
      textAlign: 'center',
    }}
  >
    <i className="fas fa-ban" style={{ fontSize: '4rem', color: '#e74c3c', marginBottom: '1rem' }} />
    <h1 style={{ color: '#2c3e50', marginBottom: '0.5rem' }}>403 — Forbidden</h1>
    <p style={{ color: '#7f8c8d', marginBottom: '1.5rem' }}>
      You don&apos;t have permission to access this page.
    </p>
    <Link
      to="/dashboard"
      style={{
        background: '#1a4f8c',
        color: '#fff',
        padding: '0.6rem 1.2rem',
        borderRadius: '6px',
        textDecoration: 'none',
        fontWeight: 500,
      }}
    >
      Back to Dashboard
    </Link>
  </div>
);

export default ForbiddenPage;
